export default {
  columns: { },
};
